import { render, staticRenderFns } from "./HshMessageHandler.vue?vue&type=template&id=99d8e196&scoped=true"
import script from "./HshMessageHandler.vue?vue&type=script&lang=js"
export * from "./HshMessageHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d8e196",
  null
  
)

export default component.exports